module.exports = __webpack_public_path__ + "static/media/WecanTokenize_tagline.52d4d744.svg";